import axios from './api';
import { showSnackbar } from 'redux/Action';

export default {
    setupInterceptors: (history, store) => {

        axios.interceptors.response.use(response => {
            return response;
        }, error => {
            if (error.response.status === 404) {
            //    history.push('/edit-profile');
                store.dispatch(showSnackbar(true, 'error', error.response.data.message));
            } else if (error.response.status === 401)
            {
                history.push('/sign-in');

            }
            else if (error.response.status === 422) {
                //    history.push('/edit-profile');
                    store.dispatch(showSnackbar(true, 'error', error.response.data.message));
                } 


            return Promise.reject(error);
        });
    },
};